module.exports = __webpack_public_path__ + "static/media/home2icons2.3f2e93f7.svg";